import React from "react";
import "./login.css";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
} from "mdbreact";
import allStrings from "../../assets/strings";
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import {setUser} from '../../redux/actions/AuthActions'
import {hasValue} from '../../validations/validations'
import {message} from 'antd';
import {NavLink} from 'react-router-dom';
import ReCAPTCHA from "react-google-recaptcha"

class Login extends React.Component {
  state = {
    email: "",
    password: "",
    reCaptcha:false,
    verifycode:'',
    step:1
  };

  constructor(props){
    super(props)
    console.log("isr   ",this.props.history)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    } 
    window.scrollTo(0,0)
  }

  login = () =>{
      const {email,password,reCaptcha} = this.state
      if(hasValue(email)&&hasValue(password) && reCaptcha === true){

        let l = message.loading('Wait..', 2.5)
        console.log("HAS VAL")
        const data={
            email:email,
            password:password
        }
        axios.post(`${BASE_END_POINT}loginByMail`,JSON.stringify(data),{
            headers:{
                "Content-Type":"application/json",
                'Accept-Language':this.props.isRTL?'ar':'en'
            }
        })
        .then(response=>{ 
          if(response.data.user.type !=='USER'){
            this.setState({step:2})
          }else{
            l.then(() => message.error(allStrings.thisUserIsnotAdmin, 2.5))
          }
            console.log("done")
        })
        .catch(error=>{
            console.log("ERROR   ",error.response)
            l.then(() => message.error(allStrings.userDataIncorrect, 2.5))
           
        })
      }
  }
  confirmCode = () =>{
    const {email,password,verifycode} = this.state
    if(hasValue(email)&&hasValue(password) &&hasValue(verifycode)){

      let l = message.loading('Wait..', 2.5)
      console.log("HAS VAL")
      const data={
          email:email,
          password:password,
          verifycode:verifycode,
      }
      axios.post(`${BASE_END_POINT}confirmEmailCode`,JSON.stringify(data),{
          headers:{
              "Content-Type":"application/json",
              'Accept-Language':this.props.isRTL?'ar':'en'
          }
      })
      .then(response=>{ 
          if(response.data.user.type !=='USER'){

              l.then(() => message.success(allStrings.welcome, 2.5) )
              this.props.setUser(response.data)
              localStorage.setItem('@USERWASHTO7B',JSON.stringify(response.data))
              localStorage.setItem("@LANG",'ar')
              this.props.history.replace('/Home') 
              
              
          }else{
             l.then(() => message.error(allStrings.wrongCode, 2.5))
          }
      })
      .catch(error=>{
          console.log("ERROR   ",error.response)
          l.then(() => message.error(allStrings.userDataIncorrect, 2.5))
         
      })
    }
}

  submitHandler = (event) => {
    event.preventDefault();
    console.log(event.target);
    event.target.className += " was-validated";
    if(this.state.step === 1){
      this.login()
    }else{
      this.confirmCode()
    }
  };

  changeHandler = (event) => {
    console.log(event.target.value);
    this.setState({ [event.target.name]: event.target.value });
  };
  onChange = (value) =>{
    console.log("Captcha value:", value);
    if(value)
      this.setState({reCaptcha:true})
  }
  render() {
     
    return (
      <div className="login">
        <MDBContainer className="loginContainer">
          <MDBRow>
            <MDBCol  xl="6" lg="6" md="4" sm="12" className="noPadding">
              <div className="loginLeft">

              </div>
            </MDBCol>
            <MDBCol  xl="6" lg="6" md="8" sm="12">
              <div className="loginRight">
                <div className="logoDiv">
                  <img alt="" style={{

                      margin: 'auto',
                      display: 'block',
                      marginTop: '4rem'
                  }} width="200px" src={require('../../assets/images/logo-1.svg')}></img>
                </div>
                <br></br>
                <div className="formContainer">
                <MDBContainer>
                      <MDBRow>
                        <MDBCol md="12">
                          <form
                            className="needs-validation"
                            onSubmit={this.submitHandler}
                            noValidate
                          >
                            
                            {this.state.step === 1 ?
                            <div>
                              <div className="grey-text">
                                <MDBInput
                                  name="email" hint={allStrings.email}
                                  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}}
                                  group type="email" onChange={this.changeHandler}
                                  required validate error="wrong" success="right"
                                />
                                <div className="valid-feedback">Looks good!</div>
                                <MDBInput
                                  onChange={this.changeHandler} name="password" required hint={allStrings.password}
                                  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}}
                                  group type="password" validate
                                />
                                <div className="valid-feedback">Looks good!</div>
                              </div>
                              <ReCAPTCHA 
                              sitekey="6LduqqQiAAAAAPbAWRHAsfAqqTqNLi5Xcpv0zffO"
                              size="normal"
                              onChange={this.onChange}
                              />
                              <NavLink to="/forgetPassword">
                                <p className="forgetP">{allStrings.forgetPassword}</p>
                              </NavLink>
                            </div>
                            :
                            <div>
                              <div className="grey-text">
                                <div className="md-form">
                                  <input placeholder={allStrings.verificationCode} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} type="text" id="form645" name="verifycode" className="form-control" onChange={this.changeHandler} required  validate/>
                                  <div class="valid-feedback">{allStrings.correct}</div>
                                  <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                </div>
                              </div>
                            </div>
                            }
                            
                            
                            <div className="text-center">
                              <MDBBtn
                                type="submit"
                                style={{ backgroundColor: '#117183 ',width:'170px' }}
                                rounded
                                className="btn z-depth-1a"
                              >
                                {this.state.step===1?allStrings.signin:allStrings.check}
                              </MDBBtn>
                            </div>
                          </form>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

const mapToStateProps = state => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  })
  
  const mapDispatchToProps = {
    setUser,
  }
  
  export default  withRouter(
    connect(mapToStateProps,mapDispatchToProps)(Login)
  );
  
